import { Avatar, Box, ButtonBase, Typography, alpha } from '@mui/material';
import React, { FC, useCallback } from 'react';
import Logo from './Logo';
import { importantCSS } from '../viewsUtils';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Routes } from 'src/routes';
import { routingOnRouteRequest } from 'src/app/store/routingSlice';
import { detailsDrawerInit } from 'src/DetailsDrawer/store/detailsDrawerSlice';

type OwnProps = {
  gap?: number;
  logoHeight?: number;
  titleFontSize?: number;
  clickable?: boolean;
};

type Props = OwnProps & ReturnType<typeof mapDispatchToProps>;

const TitledLogo: FC<Props> = ({
  gap = 1.5,
  titleFontSize = 3.125,
  logoHeight = 3,
  clickable = true,
  goHome,
}) => {
  const onClick = useCallback(() => {
    if (!clickable) return;
    // Do something
    goHome();
  }, [clickable, goHome]);

  return (
    <ButtonBase
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap',
        gap: ({ spacing }) => spacing(gap),
        cursor: clickable ? 'pointer' : 'default',
        borderRadius: 10,
      }}
      onClick={onClick}
    >
      <Avatar
        sx={{
          height: ({ spacing }) => importantCSS(spacing(logoHeight + 1.5)),
          width: ({ spacing }) => importantCSS(spacing(logoHeight + 1.5)),
          bgcolor: ({ palette }) => alpha(palette.primary.main, 0.25),
          color: ({ palette }) => palette.common.white,
        }}
      >
        <Logo sx={{ height: ({ spacing }) => spacing(logoHeight) }} />
      </Avatar>
      <Typography
        variant="h4"
        sx={{
          fontSize: ({ spacing }) => spacing(titleFontSize),
          userSelect: 'none',
        }}
        fontWeight={700}
        noWrap
        component="div"
        color="primary"
      >
        חשבוניתה
      </Typography>
    </ButtonBase>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goHome: () => dispatch(routingOnRouteRequest({ path: Routes.Root })),
});

export default connect(null, mapDispatchToProps)(TitledLogo);
